/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coming_In_Phase_4Inputs */

const en_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming in Phase 4`)
};

const es_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente en la fase 4`)
};

const fr_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir dans la phase 4`)
};

const de_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommt in Phase 4`)
};

const ja_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェーズ4で提供予定`)
};

const zh_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将在第 4 阶段推出`)
};

const ar_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة في المرحلة 4`)
};

const id_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hadir di Fase 4`)
};

const it_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In arrivo nella Fase 4`)
};

const ru_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидается в Фазе 4`)
};

const pt_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em breve na Fase 4`)
};

const ko_coming_in_phase_4 = /** @type {(inputs: Coming_In_Phase_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phase 4에서 지원 예정`)
};

/**
* | output |
* | --- |
* | "Coming in Phase 4" |
*
* @param {Coming_In_Phase_4Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const coming_in_phase_4 = /** @type {((inputs?: Coming_In_Phase_4Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coming_In_Phase_4Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coming_in_phase_4(inputs)
	if (locale === "es") return es_coming_in_phase_4(inputs)
	if (locale === "fr") return fr_coming_in_phase_4(inputs)
	if (locale === "de") return de_coming_in_phase_4(inputs)
	if (locale === "ja") return ja_coming_in_phase_4(inputs)
	if (locale === "zh") return zh_coming_in_phase_4(inputs)
	if (locale === "ar") return ar_coming_in_phase_4(inputs)
	if (locale === "id") return id_coming_in_phase_4(inputs)
	if (locale === "it") return it_coming_in_phase_4(inputs)
	if (locale === "ru") return ru_coming_in_phase_4(inputs)
	if (locale === "pt") return pt_coming_in_phase_4(inputs)
	return ko_coming_in_phase_4(inputs)
});